import { render, staticRenderFns } from "./LanguageObjectInput.vue?vue&type=template&id=31ddc18a"
import script from "./LanguageObjectInput.vue?vue&type=script&lang=js"
export * from "./LanguageObjectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports